import React, { useCallback, useEffect, useRef, useState } from "react";
import { BiArrowFromLeft, BiLoader } from "react-icons/bi";
import { FaMinus, FaPlus } from "react-icons/fa";
import { motion } from "framer-motion";
import { connectSocket, getSocket } from "../utils/Socket";

const defaultMsg =
  "Hi there! Kawal Jain this side 😊 You're now chatting with an AI version of me. Feel free to ask anything about my resume—whether it's my work experience, education, skills, hobbies, or even fun facts!";
function Chat({ userId }) {
  const [showChatBox, setShowChatBox] = useState(false);
  const [inputMsg, setInputMsg] = useState("");
  const [socketReady, setSocketReady] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false); // Track streaming state

  const [messages, setMessages] = useState([]);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    const socket = getSocket();
    if (socket && socket.connected) {
      setSocketReady(true);
    } else {
      const interval = setInterval(() => {
        const s = getSocket();
        if (s && s.connected) {
          clearInterval(interval);
          setSocketReady(true);
        }
      }, 100);
    }
  }, []);

  useEffect(() => {
    if (!socketReady) return;

    let socket = getSocket();

    const handleReplyFromBot = (reply) => {
      setIsLoading(() => false);
      setIsStreaming(() => false);

      setTimeout(() => {}, 100);
      setMessages((prev) => [
        ...prev,
        {
          role: "model",
          type: "response",
          content: reply,
        },
      ]);
      // await initChatApi();
    };

    const handleTyping = async (msg) => {
      setIsLoading(() => true);
      setIsStreaming(() => true);
    };

    socket.on("typing", handleTyping);

    socket.on("message_from_kawal", handleReplyFromBot);

    return () => {
      socket.off("message_from_kawal", handleReplyFromBot);
      socket.off("typing", handleTyping);
    };
  }, [socketReady]);

  const onChatBoxHandler = () => {
    setShowChatBox(!showChatBox);
  };

  const handleKeyDown = (event) => {
    if (isStreaming || isLoading) {
      return;
    }
    if (event.key === "Enter") {
      event.preventDefault();
      handleSendMessage();
    }
  };
  const handleInputChange = (event) => {
    setInputMsg(event.target.value);
  };

  const handleSendMessage = async () => {
    if (!inputMsg.trim() || isLoading) return; // Don't send empty messages or if loading

    const userMessage = {
      role: "user",
      text: inputMsg,
      content: inputMsg,
      parts: [{ text: inputMsg }],
    };
    const newMessages = [...messages, userMessage];

    setMessages(newMessages);
    setInputMsg("");
    // setIsLoading(true);
    // setIsStreaming(true); // Reset streaming state for new response

    try {
      const socket = getSocket();
      socket.emit("message_from_client", {
        history: messages,
        newMsg: userMessage,
      });
    } catch (error) {
      // console.log(error);
    }
  };

  const handleMessageRender = () => {
    return (
      <>
        <div className={`message system mb-3`}>
          <span className="prompt">$</span>
          {defaultMsg}
        </div>
        {messages.map((message, index) => {
          return (
            <div
              key={`chat-message-${index}`}
              className={`message mb-3 ${
                message.role === "model" ? "system" : "user"
              } mb-3`}
            >
              <span className="prompt">
                {message.role === "model" ? "$" : ">"}
              </span>
              {message.content}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div
      className="card terminal-window"
      style={showChatBox ? {} : { height: "40px" }}
    >
      <div className="card-header terminal-header p-2 d-flex align-items-center">
        <div className="window-controls me-2">
          <div className="control red" onClick={onChatBoxHandler}>
            {!showChatBox ? (
              <FaPlus size={10} color="black" />
            ) : (
              <FaMinus size={10} color="black" />
            )}
          </div>
          {/* <span className="control yellow">
            <BiZoomIn size={10} color="black" />{" "}
          </span> */}
          {/* <span className="control red"></span> */}
          {/* <span className="control yellow"></span>
          <span className="control green"></span> */}
        </div>
        <span className="terminal-title">kawalJain@mac-terminal ~ /chat</span>
      </div>
      <div
        className="card-body terminal-body p-3"
        id="chatMessageArea"
        ref={chatContainerRef}
        style={showChatBox ? { display: "block" } : { display: "none" }}
      >
        {handleMessageRender()}
        {isLoading && (
          <motion.div>
            <BiLoader className="spinner mr-3" />
            {isStreaming ? "hmmmm..." : "Kawal is typing...."}
          </motion.div>
        )}
      </div>
      <div
        className="card-footer terminal-footer p-2"
        style={showChatBox ? { display: "block" } : { display: "none" }}
      >
        <div className="input-group">
          <span className="input-group-text terminal-prompt">$</span>
          <input
            type="text"
            className="form-control terminal-input"
            placeholder="Type your message... z"
            value={inputMsg}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
          />
          <div className="btn btn-terminal" onClick={handleSendMessage}>
            {isLoading ? (
              <BiLoader className="spinner mr-3" />
            ) : (
              <>
                <BiArrowFromLeft />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chat;
